import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Why Choose Moosera</h2>
            <p className="about-description">
              At Moosera, we're a new venture built on deep expertise and a passion for AI innovation. 
              We're not just building AI applications—we're crafting intelligent systems that transform 
              how businesses operate. Our team brings years of individual experience in AI development, 
              combining technical expertise with fresh perspectives to deliver exceptional solutions.
            </p>
            <div className="about-features">
              <div className="about-feature">
                <h3>🎓 Expert Team</h3>
                <p>
                  Our engineers and data scientists have years of experience in machine learning, 
                  NLP, and autonomous systems, working with the latest AI technologies including 
                  GPT-4, Claude, and custom models.
                </p>
              </div>
              <div className="about-feature">
                <h3>🚀 Agile & Innovative</h3>
                <p>
                  As a new company, we bring fresh thinking and cutting-edge approaches without 
                  legacy constraints. We're nimble, responsive, and committed to staying ahead of 
                  the rapidly evolving AI landscape to deliver the best solutions.
                </p>
              </div>
              <div className="about-feature">
                <h3>🔒 Security First</h3>
                <p>
                  All our AI solutions are built with enterprise-grade security, compliance with 
                  industry standards (GDPR, HIPAA, SOC 2), and robust data governance frameworks.
                </p>
              </div>
              <div className="about-feature">
                <h3>🤝 Partnership Approach</h3>
                <p>
                  We work alongside your team as strategic partners, providing ongoing support, 
                  training, and continuous optimization to ensure long-term success of your AI initiatives.
                </p>
              </div>
            </div>
          </div>
          <div className="about-values">
            <div className="value-card">
              <h4>Our Mission</h4>
              <p>
                To democratize AI technology by making advanced AI solutions accessible, 
                practical, and impactful for businesses of all sizes.
              </p>
            </div>
            <div className="value-card">
              <h4>Our Approach</h4>
              <p>
                We believe in human-centered AI design, where technology augments human 
                capabilities rather than replacing them, creating sustainable value.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

